import { render, staticRenderFns } from "./OtherActions.vue?vue&type=template&id=4ebf661c&scoped=true&"
import script from "./OtherActions.vue?vue&type=script&lang=js&"
export * from "./OtherActions.vue?vue&type=script&lang=js&"
import style0 from "./OtherActions.vue?vue&type=style&index=0&id=4ebf661c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebf661c",
  null
  
)

export default component.exports